<template>
  <div>
    <div class="PassWordTop">
      <div class="PassWordT">
      </div>
      <div class="PassWordB">
        <div class="PassWordBN">
          <img src="../../../../assets/channel/login/login-bg-top.png" alt="" class="PassWordlogin">
          <div class="verticalLine">
            |
          </div>
          <div class="PassWordText">
            忘记密码
          </div>
          <div class="GoBackLogin" @click="GoBackLogin">
            返回登录<img src="../../../../assets/channel/login/info-red.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="ForgetPassword">
      <div class="phone">
        <img src="../../../../assets/channel/login/phone.png" alt="" v-if="updateFlag == 1">
        <img src="../../../../assets/channel/login/forget_wc_s.png" alt="" v-else>
        手机号验证
      </div>
      <div :class="[ updateFlag == 1 ? 'line1' : 'line1-1']"></div>
      <div class="update">
        <img src="../../../../assets/channel/login/forget_passwprd_n.png" alt="" v-if="updateFlag == 1">
        <img src="../../../../assets/channel/login/forget_wc_s.png" alt="" v-else-if="updateSuccessFlag == 2">
        <img src="../../../../assets/channel/login/forget_passwprd_s.png" alt="" v-else>
        <div style="display: inline-block;color: #9CA5B8;" v-if="updateFlag == 1">
          修改密码
        </div>
        <div style="display: inline-block;" v-else>
          修改密码
        </div>
      </div>
      <div :class="[ updateSuccessFlag == 1 ? 'line2' : 'line2-2']"></div>
      <div class="updateSuccess">
        <img src="../../../../assets/channel/login/forget_wc_n.png" alt="" v-if="updateSuccessFlag == 1">
        <img src="../../../../assets/channel/login/forget_wc_s.png" alt="" v-else>
        <div style="display: inline-block;color: #9CA5B8;" v-if="updateSuccessFlag == 1">
          修改成功
        </div>
        <div style="display: inline-block;" v-else>
          修改成功
        </div>
      </div>
      <div class="line3"></div>
      <div class="Center">
        <img src="../../../../assets/channel/login/leftLogin.png" alt="">
        修改密码
        <img src="../../../../assets/channel/login/right.png" alt="">
      </div>
      <div class="CodeInput" v-if="updateFlag == 1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
          <input type="text" v-model="ruleForm.userName" placeholder="请输入手机号" class="userNameCss" />
          <input type="password" v-model="ruleForm.password" placeholder="请输入验证码" class="passWordCss" />
          <div class="CodeBtn" @click="CodeClick" v-if="CodeFlag">发送验证码</div>
          <div class="CodeBtnTime" v-else>重新获取（{{ Second }}s）</div>
          <div @click="onSubmitPhone" class="btn-OK-submit">验证手机</div>
        </el-form>
      </div>
      <div class="CodeInput" v-else-if="updateFlag == 2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ruleForm">
          <input type="password" v-model="ruleForm.userName" placeholder="请输入新密码" class="userNameCss" />
          <input type="password" v-model="ruleForm.password" placeholder="请确认新密码" class="userNameCss" />
          <div @click="onSubmitPhone" class="btn-OK-submit">确认修改</div>
        </el-form>
      </div>
      <div class="passwordSuccess" v-else-if="updateSuccessFlag == 2">
        <div class="passwordSuccess-img">
          <img src="../../../../assets/channel/login/passwordSuccess.png" alt="">
        </div>
        <div class="text1">
          修改密码成功
        </div>
        <div class="text2">
          你的密码已修改成功，返回登录体验更多功能
        </div>
        <div class="line4"></div>
        <div class="backLogin" @click="GoBackLogin">返回登录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      updateFlag: 1,//控制修改密码
      updateSuccessFlag: 1,//控制修改密码成功
      CodeFlag: true,
      Timer: null, //计时器
      Second: "", //倒计时秒
      ruleForm: {
        userName: '',
        password: ''
      },
      rules: {}
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    // 获取验证码
    CodeClick() {
      this.$notify({
        type: 'warning',
        title: '警告',
        message: '当前未开通短信功能，请联系管理人员进行密码重置',
        duration: 0
      });

      // this.CodeFlag = false
      // const TIME_COUNT = 60; //倒计时秒
      // if (!this.Timer) {
      //   this.Second = TIME_COUNT
      //   this.Timer = setInterval(() => {
      //     if (this.Second > 0 && this.Second <= TIME_COUNT) {
      //       this.Second--
      //     } else {
      //       this.CodeFlag = true;
      //       clearInterval(this.Timer)
      //       this.Timer = null
      //     }
      //   }, 1000)
      // }
    },
    onSubmitPhone() {
       this.$notify({
        type: 'warning',
        title: '警告',
        message: '当前未开通短信功能，请联系管理人员进行密码重置',
        duration: 0
      });
    },
    GoBackLogin() {
      this.$router.push({
        path: '/login/CodeLoginPage'
      })
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.ForgetPassword {
  width: 1180px;
  height: 640px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebedf0;
  margin: 16px auto;
  overflow: hidden;
  position: relative;
  user-select: none;

  .phone {
    position: relative;
    left: 150px;
    top: 32px;
    font-size: 17px;
    color: #00266d;
    font-weight: 500;
  }
  .line1 {
    width: 104px;
    border-bottom: 2px dotted #ced3d9;
    position: absolute;
    left: 350px;
    top: 52px;
  }
  .line1-1 {
    width: 104px;
    border-bottom: 2px dotted #00266d;
    position: absolute;
    left: 350px;
    top: 52px;
  }
  .update {
    position: relative;
    left: 530px;
    top: -10px;
    font-size: 17px;
    color: #00266d;
    font-weight: 500;
  }
  .line2 {
    width: 104px;
    border-bottom: 2px dotted #ced3d9;
    position: absolute;
    left: 730px;
    top: 52px;
  }
  .line2-2 {
    width: 104px;
    border-bottom: 2px dotted #00266d;
    position: absolute;
    left: 730px;
    top: 52px;
  }
  .line4 {
    width: 1180px;
    height: 1px;
    position: absolute;
    top: 576px;
    left: 0px;
    background: #ebedf0;
  }
  .line3 {
    width: 1180px;
    height: 1px;
    position: relative;
    top: -30px;
    background: #ebedf0;
  }
  .updateSuccess {
    position: relative;
    left: 900px;
    top: -55px;
    font-size: 17px;
    color: #00266d;
    font-weight: 500;
  }
  .Center {
    height: 33px;
    width: 100%;
    line-height: 33px;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #00266d;
    img {
      vertical-align: middle;
    }
    img:nth-child(2) {
      margin-left: 10px;
    }
  }
  .passwordSuccess {
    width: 100px;
    height: 100px;
    margin: 48px auto;
    // .passwordSuccess-img {
    // }
  }
  .text1 {
    width: 108px;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #00266d;
    position: relative;
    right: 5px;
    top: 10px;
  }
  .text2 {
    width: 280px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #9ca5b8;
    position: relative;
    right: 85px;
    top: 10px;
  }
  .backLogin {
    width: 106px;
    height: 40px;
    background: #e71d43;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    position: absolute;
    top: 588px;
    left: 804px;
    cursor: pointer;
  }
  .CodeInput {
    width: 401px;
    // border: 1px solid rebeccapurple;
    margin: 0 auto;
    .userNameCss {
      width: 390px;
      height: 40px;
      border: 1px solid #e6e8eb;
      background: #fafbfc;
      border-radius: 2px;
      font-size: 14px;
      margin-top: 16px;
      padding-left: 10px;
    }
    .passWordCss {
      width: 254px;
      height: 40px;
      border: 1px solid #e6e8eb;
      background: #fafbfc;
      border-radius: 2px;
      font-size: 14px;
      padding-left: 10px;
      margin-top: 20px;
    }

    .btn-OK-submit {
      width: 100%;
      height: 40px;
      background-color: #e71d43;
      text-align: center;
      font-size: 14px;
      color: #fff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-top: 20px;
      line-height: 40px;
      cursor: pointer;
    }
    .CodeBtn {
      display: inline-block;
      width: 120px;
      height: 40px;
      background-color: #e71d43;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      color: #fff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-left: 15px;
      cursor: pointer;
    }
    .CodeBtnTime {
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      background-color: #ced3d9;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      font-family: "微软雅黑";
      border-radius: 2px;
      margin-left: 15px;
      cursor: pointer;
    }
  }

  img {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.PassWordTop {
  width: 100%;

  .PassWordT {
    max-width: 100%;
    min-width: 1180px;
    height: 8px;
    background: #00266d;
  }
  .PassWordB {
    max-width: 100%;
    min-width: 1180px;
    height: 64px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #e6e7eb;

    .PassWordBN {
      width: 1180px;
      height: 100%;
      margin: 0 auto;
      position: relative;

      .PassWordlogin {
        width: 95px;
        height: 35px;
        margin-top: 16px;
      }
      .verticalLine {
        color: #e1e3e6;
        display: inline-block;
        position: relative;
        top: -15px;
        left: 22px;
      }
      .PassWordText {
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        color: #00266d;
        position: relative;
        top: -12px;
        left: 44px;
        user-select: none;
      }
      .GoBackLogin {
        font-size: 18px;
        font-weight: 500;
        color: #e71d43;
        line-height: 64px;
        margin-right: 20px;
        float: right;
        cursor: pointer;
        user-select: none;

        img {
          vertical-align: middle;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>